const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.CAMPAIGN_REPORTS)
const codeReportsPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.DISCOUNT_CODE_REPORTS)

export const apiCampaignReports = {
	fetchCampaignReports: async ({
		page,
		perPage,
		dateRange,
		search,
	}: {
		page?: number
		perPage?: number
		dateRange?: string
		search?: string
	} = {}): Promise<IApiResponseModel<ICampaignReportModel[]>> => {
		const { data, meta } = await apiCommon<ICampaignReportApiItem[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(buildPagination(page, perPage), {
				search,
				date_range: dateRange,
			}),
		})
		return { data: data.map(CampaignReportItem), meta }
	},

	exportCampaignReports: async (campaignId: number, { dateRange }: { dateRange?: string } = {}): Promise<void> => {
		const response = await apiCommonRaw<BlobPart>(`${groupPrefix}/${campaignId}/export`, {
			method: 'GET',
			...createQuery(null, { date_range: dateRange }),
			responseType: 'blob',
		})
		downloadFileFromResponse(response, 'raport-kampanii.xlsx')
	},

	fetchCodeReports: async ({
		page,
		perPage,
		dateRange,
		search,
		campaignIds,
	}: {
		page?: number
		perPage?: number
		dateRange?: string
		search?: string
		campaignIds?: number[]
	} = {}): Promise<IApiResponseModel<ICodeReportModel[]>> => {
		const { data, meta } = await apiCommon<ICodeReportApiItem[]>(`${codeReportsPrefix}`, {
			method: 'GET',
			...createQuery(buildPagination(page, perPage), {
				search,
				date_range: dateRange,
				campaigns: campaignIds,
			}),
		})
		return { data: data.map(CodeReportItem), meta }
	},

	exportCodeReports: async (
		codeId: number,
		{ dateRange, campaignIds }: { dateRange?: string; campaignIds?: number[] } = {},
	): Promise<void> => {
		const response = await apiCommonRaw<BlobPart>(`${codeReportsPrefix}/${codeId}/export`, {
			method: 'GET',
			...createQuery(null, { date_range: dateRange, campaigns: campaignIds }),
			responseType: 'blob',
		})
		downloadFileFromResponse(response, 'raport-kodow.xlsx')
	},
}
